import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import {
    FiShield,
    FiUnlock,
    FiGlobe,
    FiCpu,
    FiArrowLeft,
    FiCheckCircle
} from 'react-icons/fi';

const AboutPage = () => {
    return (
        <div className="min-h-screen bg-surface-50 dark:bg-surface-950 text-gray-700 dark:text-surface-200 py-12 px-4 sm:px-6 lg:px-8 selection:bg-mavi-500/30">
            <div className="max-w-4xl mx-auto">
                {/* Back Link */}
                <Link
                    to="/login"
                    className="inline-flex items-center text-mavi-600 dark:text-mavi-400 hover:text-mavi-700 dark:hover:text-mavi-300 transition-colors mb-8 group font-poppins font-bold text-sm"
                >
                    <FiArrowLeft className="mr-2 group-hover:-translate-x-1 transition-transform" />
                    Giriş Ekranına Dön
                </Link>

                {/* Hero Section */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-center mb-16"
                >
                    <h1 className="text-4xl sm:text-5xl font-poppins font-bold text-gray-900 dark:text-white mb-6 tracking-tight">
                        Mavililer Sözlük nedir?
                    </h1>
                    <p className="text-xl text-gray-500 dark:text-surface-400 leading-relaxed max-w-2xl mx-auto font-merriweather italic">
                        Mavililer Sözlük, yeni nesil bir sosyal ağdır. Verilerinizin kontrolü sizdedir, kimliğiniz bağımsızdır ve kaliteli bir tartışma ortamı önceliğimizdir.
                    </p>
                </motion.div>

                {/* Grid Sections */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.1 }}
                        className="bg-white dark:bg-surface-900 border border-surface-200 dark:border-surface-800 p-8 rounded-[2rem] hover:border-mavi-500/50 transition-all duration-300 group shadow-sm hover:shadow-xl"
                    >
                        <div className="mb-4 p-3 bg-surface-50 dark:bg-surface-950 rounded-2xl w-fit group-hover:scale-110 transition-transform shadow-inner">
                            <FiGlobe className="w-8 h-8 text-mavi-500" />
                        </div>
                        <h3 className="text-xl font-poppins font-bold text-gray-900 dark:text-white mb-3">
                            Özgür Teknoloji
                        </h3>
                        <p className="text-gray-500 dark:text-surface-400 leading-relaxed font-merriweather text-sm">
                            Mavililer, "Nostr" adı verilen modern bir altyapı kullanır. Verileriniz tek bir merkeze bağlı kalmak yerine, bağımsız sunucular (relay) aracılığıyla tüm dünyada güvenle saklanır.
                        </p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                        className="bg-white dark:bg-surface-900 border border-surface-200 dark:border-surface-800 p-8 rounded-[2rem] hover:border-mavi-500/50 transition-all duration-300 group shadow-sm hover:shadow-xl"
                    >
                        <div className="mb-4 p-3 bg-surface-50 dark:bg-surface-950 rounded-2xl w-fit group-hover:scale-110 transition-transform shadow-inner">
                            <FiShield className="w-8 h-8 text-green-500" />
                        </div>
                        <h3 className="text-xl font-poppins font-bold text-gray-900 dark:text-white mb-3">
                            Gerçek Sahiplik
                        </h3>
                        <p className="text-gray-500 dark:text-surface-400 leading-relaxed font-merriweather text-sm">
                            Hesabınızın kontrolü tamamen sizdedir. Giriş yaparken kullandığınız 12 kelimeye sahip olduğunuz sürece, dijital kimliğiniz her zaman size ait kalmaya devam eder.
                        </p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3 }}
                        className="bg-white dark:bg-surface-900 border border-surface-200 dark:border-surface-800 p-8 rounded-[2rem] hover:border-mavi-500/50 transition-all duration-300 group shadow-sm hover:shadow-xl"
                    >
                        <div className="mb-4 p-3 bg-surface-50 dark:bg-surface-950 rounded-2xl w-fit group-hover:scale-110 transition-transform shadow-inner">
                            <FiUnlock className="w-8 h-8 text-purple-500" />
                        </div>
                        <h3 className="text-xl font-poppins font-bold text-gray-900 dark:text-white mb-3">
                            Nitelikli Moderasyon
                        </h3>
                        <p className="text-gray-500 dark:text-surface-400 leading-relaxed font-merriweather text-sm">
                            Huzurlu bir sözlük deneyimi için aktif moderasyon uyguluyoruz. Altyapı özgür olsa da, topluluk kurallarımızla kaosun önüne geçiyor ve seviyeli bir tartışma ortamı sağlıyoruz.
                        </p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4 }}
                        className="bg-white dark:bg-surface-900 border border-surface-200 dark:border-surface-800 p-8 rounded-[2rem] hover:border-mavi-500/50 transition-all duration-300 group shadow-sm hover:shadow-xl"
                    >
                        <div className="mb-4 p-3 bg-surface-50 dark:bg-surface-950 rounded-2xl w-fit group-hover:scale-110 transition-transform shadow-inner">
                            <FiCpu className="w-8 h-8 text-orange-500" />
                        </div>
                        <h3 className="text-xl font-poppins font-bold text-gray-900 dark:text-white mb-3">
                            Sınır Tanımayan Kimlik
                        </h3>
                        <p className="text-gray-500 dark:text-surface-400 leading-relaxed font-merriweather text-sm">
                            Mavililer hesabınızla diğer tüm uyumlu uygulamalara da erişebilirsiniz. Bir yerde yazdığınız her şey, kimliğinizle birlikte diğer merkeziyetsiz ağlara da taşınabilir.
                        </p>
                    </motion.div>
                </div>

                {/* New Section: What is Nostr? */}
                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    className="mb-16 bg-white dark:bg-surface-900/50 border border-surface-200 dark:border-surface-800 p-10 rounded-[3rem] overflow-hidden relative"
                >
                    <div className="absolute top-0 right-0 p-8 opacity-5">
                        <FiCpu size={160} />
                    </div>
                    <div className="relative z-10">
                        <h2 className="text-3xl font-poppins font-bold text-gray-900 dark:text-white mb-6">
                            Nostr Nedir?
                        </h2>
                        <div className="space-y-6 text-lg text-gray-600 dark:text-surface-300 font-merriweather leading-relaxed max-w-3xl">
                            <p>
                                Nostr, "Notes and Other Stuff Transmitted by Relays" ifadesinin kısaltmasıdır. Bu, karmaşık sunucu sistemleri yerine basit, açık ve herkes tarafından kullanılabilen bir iletişim dilidir.
                            </p>
                            <p>
                                Geleneksel sosyal ağlarda içerikleriniz o şirketin mülküdür. Nostr'da ise içerikleriniz sadece size ait olan matematiksel bir imza ile korunur. Bu sayede hiçbir merkezi güç sizin sesinizi kısamaz veya hesabınızı mülkünden çıkaramaz.
                            </p>
                        </div>
                    </div>
                </motion.div>

                {/* New Section: Continuity and Portability */}
                <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    className="mb-16 bg-gradient-to-br from-mavi-500 to-mavi-700 text-white p-10 rounded-[3rem] shadow-2xl relative overflow-hidden"
                >
                    <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
                        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white rounded-full blur-3xl opacity-20"></div>
                        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-mavi-300 rounded-full blur-3xl opacity-20"></div>
                    </div>

                    <div className="relative z-10 max-w-3xl">
                        <h2 className="text-3xl font-poppins font-bold mb-6 flex items-center">
                            <FiGlobe className="mr-4 text-mavi-100" />
                            Sözlük Kapansa Bile Yanınızdayız
                        </h2>
                        <div className="space-y-6 text-lg font-merriweather leading-relaxed text-mavi-50">
                            <p>
                                Bir gün Mavililer Sözlük tamamen kapansa veya erişilemez olsa bile, hiçbir yazınız veya bilginiz kaybolmaz. Verileriniz dünya çapındaki binlerce bağımsız sunucuda (relay) saklanmaya devam eder.
                            </p>
                            <p className="bg-white/10 p-6 rounded-2xl backdrop-blur-sm border border-white/20 shadow-inner">
                                Sadece giriş yaptığınız 12 kelimeyi kullanarak başka bir sözlük sitesine veya Nostr uyumlu herhangi bir uygulamaya girdiğinizde; tüm entry'lerinizi, profilinizi ve takipçilerinizi anında bıraktığınız yerden geri alabilirsiniz.
                            </p>
                            <p className="text-sm font-poppins font-semibold uppercase tracking-wider text-mavi-100 opacity-90">
                                Gerçek özgürlük, hiçbir yere mecbur olmamaktır.
                            </p>
                        </div>
                    </div>
                </motion.div>

                {/* Why 12 Words? */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5 }}
                    className="bg-gradient-to-br from-mavi-500/5 to-purple-500/5 dark:from-mavi-500/10 dark:to-purple-500/10 border border-mavi-200 dark:border-mavi-500/20 p-8 rounded-[2.5rem] shadow-lg"
                >
                    <h2 className="text-2xl font-poppins font-bold text-gray-900 dark:text-white mb-4 flex items-center">
                        <FiCheckCircle className="mr-3 text-mavi-500" />
                        Neden 12 Kelime?
                    </h2>
                    <div className="space-y-4 text-gray-600 dark:text-surface-300 font-merriweather">
                        <p>
                            Mavililer sözlükte şifre yerine matematiksel olarak türetilen bir anahtar sistemi kullanılır. Bu sistemin kalbi ise size verdiğimiz 12 kelimedir.
                        </p>
                        <ul className="list-disc list-inside space-y-2 text-gray-500 dark:text-surface-400">
                            <li><strong className="text-gray-900 dark:text-white">Şifre sıfırlama yoktur:</strong> Kelimeleri kaybederseniz hesabınıza (ve kimliğinize) erişiminiz kalıcı olarak kesilir.</li>
                            <li><strong className="text-gray-900 dark:text-white">Tam taşınabilirlik:</strong> Kimliğinizi istediğiniz zaman başka uygulamalara taşıyabilirsiniz.</li>
                            <li><strong className="text-gray-900 dark:text-white">Üst düzey güvenlik:</strong> 12 kelimelik anahtarınızı başkalarının ele geçirmesi imkansıza yakındır.</li>
                        </ul>
                    </div>
                </motion.div>

                {/* CTA */}
                <div className="mt-16 text-center">
                    <Link
                        to="/login"
                        className="inline-block bg-mavi-500 hover:bg-mavi-600 text-white font-poppins font-bold py-4 px-12 rounded-2xl transition-all hover:scale-105 shadow-xl shadow-mavi-500/20"
                    >
                        Hemen Başla
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default AboutPage;
